var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.635 15.18c-.348.348-.359.943 0 1.292a.941.941 0 001.302 0L8.5 9.909l6.563 6.563c.348.348.953.359 1.302 0a.929.929 0 000-1.292L9.802 8.607l6.563-6.563c.348-.348.359-.943 0-1.292a.922.922 0 00-1.302 0L8.5 7.315 1.937.752C1.59.394.985.383.635.752a.929.929 0 000 1.292l6.563 6.563L.635 15.18z"
  })));
}

export default SvgCross;